import React, { useState } from "react";

import GraphqlWrapper from "GraphQL/GraphqlWrapper";

import Table from "./Table";
import GridPropsQuery from "../../lib/AgGrid/GridPropsQuery";
import AddUsersModal from "./AddUsersModal";

const ContractHOUsersApp = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [gridApi, setGridApi] = useState(null);

  const onGridReady = (params) => {
    setGridApi(params.api);
  };

  const handleModalClose = () => {
    setIsModalOpen(false);
    if (gridApi) {
      gridApi.refreshServerSide();
    }
  };

  return (
    <GraphqlWrapper>
      <GridPropsQuery
        render={({ contractCodes, currentUser }) => (
          <section className="contract_ho_users_section">
            <div style={{ marginBottom: "15px" }}>
              <button 
                className="button aidacare"
                onClick={() => setIsModalOpen(true)}
              >
                Add users to contract
              </button>
            </div>
            <Table 
              contractCodes={contractCodes} 
              currentUser={currentUser} 
              onGridReady={onGridReady}
            />
            {isModalOpen && (
              <AddUsersModal 
                onClose={handleModalClose} 
                currentUser={currentUser}
              />
            )}
          </section>
        )}
      />
    </GraphqlWrapper>
  );
};

export default ContractHOUsersApp;
